import React from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/pageNotFound.css';

function PageNotFound() {
  // SSR: never render 404
  if (typeof window === 'undefined') {
    return null;
  }

  const location = useLocation();
  const path = location.pathname;

  // Do NOT render 404 for home / index variants
  if (
    path === '' ||
    path === '/' ||
    path === '/index.html' ||
    path === '/index.php'
  ) {
    return null;
  }

  return (
    <div className="pnf-container">
      <img
        src="/comedy/assets/images/page404.png"
        alt="pnf-img"
        className="pnf-img"
      />
    </div>
  );
}

export default PageNotFound;